let lastScrollTop = 0; // 用于判断滚动方向

// 创建存储对象
export const scrollStorage = {
    type: 'none', // wheel, touchmove, scroll；对应鼠标，手势，和滑动
    deviceType: 'none', // none, wheel, touchmove; 设备类型
    userDirection: 'none', // none, up, down; 用户滑动动作，不一定执行成功
    pageDirection: 'none', // none, up, down; 页面滑动方向
    scrollTopDistance: 0, // 滚动过的位置
    reset() {
        // 重置存储对象状态
        this.type = 'none';
        this.deviceType = 'none';
        this.userDirection = 'none';
        this.pageDirection = 'none';
        this.scrollTopDistance = 0;
    },
    log() {
        // 打印存储对象状态
        console.log(`滑动类型: ${this.type}`);
        console.log(`滑动设备: ${this.deviceType}`);
        console.log(`用户滑动方向: ${this.userDirection}`);
        console.log(`页面实际滑动方向: ${this.pageDirection}`);
        console.log(`滚动距离顶部的距离: ${this.scrollTopDistance}`);
    },
};

// 获取滚动位置
function getScrollTop() {
    return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

// 初始化事件监听器
(function initScrollListeners() {
    // 监听滚动、鼠标滚动、触摸滑动事件
    window.addEventListener('wheel', handleScrollEvent);
    window.addEventListener('touchmove', handleScrollEvent);
    window.addEventListener('scroll', handleScrollEvent);

    // 处理滚动事件
    function handleScrollEvent(event) {
        let scrollTop = getScrollTop(); // 获取当前滚动位置
        scrollStorage.type = event.type; // 更新事件类型
        scrollStorage.scrollTopDistance = scrollTop; // 更新滚动位置

        let deltaY = 0;

        // 针对 `wheel` 事件
        if (event.type === 'wheel') {
            deltaY = event.deltaY;
        }

        // 针对 `touchmove` 事件
        if (event.type === 'touchmove' && event.touches) {
            const currentTouchY = event.touches[0].clientY;
            deltaY = lastScrollTop - currentTouchY;
            lastScrollTop = currentTouchY; // 更新上一次的触摸位置
        }

        // 针对 `scroll` 事件
        if (event.type === 'scroll') {
            deltaY = scrollTop - lastScrollTop;
            lastScrollTop = scrollTop; // 更新上一次的滚动位置
            scrollStorage.pageDirection = deltaY > 0 ? 'down' : 'up';
        }

        // 更新用户滑动方向
        scrollStorage.userDirection = deltaY > 0 ? 'down' : 'up';

        // 记录设备类型
        if (event.type === 'wheel' || event.type === 'touchmove') {
            scrollStorage.deviceType = event.type;
        }

        // 打印日志
        // scrollStorage.log(); // 如果需要打印调试信息
    }
})();
